import { compare, parity, oddsKeyArray, oddsZodiacArray, oddsColorArray } from '../oddsKeyArray'

// 234星
const initStarKey = () => {
  // mainKey就是【玩法】
  const mainKey = 'star' // 234星
  return {
    'CHOOSE:2:MATCH:2:NL': {
      mainKey,
      supKey: 'set_two_match_two',
      groupKey: 'star2' // 二星
    },
    'CHOOSE:3:MATCH:3:NL': {
      mainKey,
      supKey: 'set_two_match_two',
      groupKey: 'star3' // 三星
    },
    'CHOOSE:4:MATCH:4:NL': {
      mainKey,
      supKey: 'set_two_match_two',
      groupKey: 'star4' // 四星

    },
    'MIX:CHOOSE:3:MATCH:2:NL': {
      mainKey,
      supKey: 'mix_set_three_match_two', // 三中二
      groupKey: 'mix_set_three_match_two'
    },
    'MIX:CHOOSE:3:MATCH:NL': {
      mainKey,
      supKey: 'mix_set_three_match_two', // 三中二
      groupKey: 'mix_set_three_match_two'
    },
    'MIX:CHOOSE:3:MATCH:3:NL': {
      mainKey,
      supKey: 'set_three_get_three', // 三中三
      groupKey: 'set_three_get_three'// 三中三
    },
    'MIX:CHOOSE:2:MATCH:2:NL': {
      mainKey,
      supKey: 'set_two_get_two', // 二中二
      groupKey: 'set_two_get_two'
    },
    'MIX:CHOOSE:2:MATCH:NL': {
      mainKey,
      supKey: 'mix_set_two_match_two', // 二中特
      groupKey: 'set_two_mix'
    },
    'MIX:CHOOSE:2:MATCH:1:NL:SP': {
      mainKey,
      supKey: 'mix_set_two_match_two', // 二中特
      groupKey: 'set_two_mix'
    }
  }
}
// 全車
const initWholeCarKey = () => {
  const mainKey = 'wholeCar'
  let arr = []
  let data = {}

  // 1:MATCH:NL 系列
  arr = Array.from({ length: 50 }, (v, i) => {
    if (i) return `${i}:MATCH:NL`
    else return ''
  }).filter(it => it)

  // ALL:SUM:OVER:NL 系列
  oddsKeyArray.forEach(it => {
    arr.push(`ALL:SUM:${it}:NL`)
  })

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey: oddsKey.split(':').length > 3 ? 'all_sum_nl' : 'set_one_match',
      groupKey: oddsKey
    }
    return root
  }, {})
  return data
}

// 正碼 的子玩法：第一球
const initPositiveCodeKey = () => {
  let data = {}

  for (let i = 1; i < 7; i++) {
    const arr = []
    let supKey = ''
    if (i === 1) supKey = 'firstBall'
    else if (i === 2) supKey = 'secondBall'
    else if (i === 3) supKey = 'thirdBall'
    else if (i === 4) supKey = 'fourthBall'
    else if (i === 5) supKey = 'fifthBall'
    else supKey = 'sixthBall'

    // 1:LOCATE:1 系列
    arr.push(...Array.from({ length: 50 }, (v, x) => {
      if (x) return `${x}:LOCATE:${i}`
      else return ''
    }).filter(it => it))

    // 1:OVER 系列
    oddsKeyArray.forEach(it => {
      arr.push(`${i}:${it}`)
    })

    // 1:DIGIT:SUM:OVER 系列
    oddsKeyArray.forEach(it => {
      arr.push(`${i}:DIGIT:SUM:${it}`)
    })

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'positiveCode',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 特碼
const initSpecialCodeKey = () => {
  const mainKey = 'sp_num' // 特碼
  let arr = []
  let data = {}

  // 1:LOCATE:SP 系列
  arr = Array.from({ length: 50 }, (v, i) => {
    if (i) return `${i}:LOCATE:SP`
    else return ''
  }).filter(it => it)

  // SP:OVER 系列
  oddsKeyArray.forEach(it => {
    arr.push(`SP:${it}`)
  })

  // SP:DIGIT:SUM:OVER 系列
  oddsKeyArray.forEach(it => {
    arr.push(`SP:DIGIT:SUM:${it}`)
  })

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey: 'sp_num', // 特碼
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 球色 的子玩法：第一球、第二球、第三球、第四球、第五球、第六球、 特碼
const initBallColorKey = (locate) => {
  let data = {}

  const fn = (oddsKey) => {
    if (oddsKey.includes('1')) return 'firstBall'
    else if (oddsKey.includes('2')) return 'secondBall'
    else if (oddsKey.includes('3')) return 'thirdBall'
    else if (oddsKey.includes('4')) return 'fourthBall'
    else if (oddsKey.includes('5')) return 'fifthBall'
    else if (oddsKey.includes('6')) return 'sixthBall'
    else if (oddsKey.includes('SP')) return 'title_sp_num'
  }

  for (let i = 1; i < 7; i++) {
    const arr = []
    // 1:BLUE 系列 、 SP:BLUE 系列
    oddsColorArray.forEach(it => arr.push(`${locate ? `${locate}` : `${i}`}:${it}`))
    // 1:BLUE:OVER 系列 、 SP:BLUE:OVER 系列
    oddsColorArray.forEach(it => compare.forEach(cit => arr.push(`${locate ? `${locate}` : `${i}`}:${it}:${cit}`)))
    // 1:BLUE:ODD 系列 、 SP:BLUE:ODD 系列
    oddsColorArray.forEach(it => parity.forEach(cit => arr.push(`${locate ? `${locate}` : `${i}`}:${it}:${cit}`)))
    // 1:BLUE:OVER:ODD 系列 、 SP:BLUE:OVER:ODD 系列
    oddsColorArray.forEach(it => compare.forEach(cit => parity.forEach(pit => arr.push(`${locate ? `${locate}` : `${i}`}:${it}:${cit}:${pit}`))))

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'ballColor',
          supKey: fn(oddsKey),
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 生肖 的子玩法：第一球、第二球、第三球、第四球、第五球、第六球
const initZodicKey = () => {
  let data = {}

  for (let i = 1; i < 7; i++) {
    const arr = []
    let supKey = ''
    if (i === 1) supKey = 'firstBall'
    else if (i === 2) supKey = 'secondBall'
    else if (i === 3) supKey = 'thirdBall'
    else if (i === 4) supKey = 'fourthBall'
    else if (i === 5) supKey = 'fifthBall'
    else supKey = 'sixthBall'

    // 1:ZODIAC:CUR 系列
    oddsZodiacArray.map(it => arr.push(`${i}:ZODIAC:${it}`))

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'zodiac',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 生肖 的子玩法： 特碼  第1至6球  平特一肖
const initZodicSpKey = (locate) => {
  const arr = []
  let data = {}
  let supKey = ''

  if (locate === 'SP') supKey = 'sp_num' // 特碼
  else if (locate === 'NL') supKey = 'set_one_match' // 第1至6球
  else if (locate === 'ALL') supKey = 'one_zodiac' // 平特一肖

  oddsZodiacArray.map(it => arr.push(`${locate}:ZODIAC:${it}`))

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey: 'zodiac',
      supKey,
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 生肖 的子玩法：一肖不中
const initNoZodicKey = (locate, status) => {
  const mainKey = 'zodiac'
  const arr = []
  let data = {}

  oddsZodiacArray.map(it => arr.push(`${locate}:ZODIAC${status ? `:${status}` : ''}:${it}`))

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey: 'no_zodic', // 一肖不中
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 總和雙面
const initSumTwoSideKey = (locate) => {
  const mainKey = 'total_two_side'
  const arr = []
  let data = {}

  oddsKeyArray.forEach(cit => {
    arr.push(`${locate}:SUM:${cit}`)
  })

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey: '',
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 特別號生肖 的子玩法： 二肖 三肖 四肖 五肖 六肖
const initSpZodicKey = () => {
  let data = {}

  for (let i = 2; i < 7; i++) {
    const arr = []
    let supKey = ''
    if (i === 2) supKey = 'zodic_2'
    else if (i === 3) supKey = 'zodic_3'
    else if (i === 4) supKey = 'zodic_4'
    else if (i === 5) supKey = 'zodic_5'
    else supKey = 'zodic_6'

    // SP:ZODIAC:CHOOSE:2:CUR 系列
    oddsZodiacArray.map(it => arr.push(`SP:ZODIAC:CHOOSE:${i}:${it}`))
    arr.push(`SP:ZODIAC:CHOOSE:${i}`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'spZodic',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 生肖連(中/不中) 的子玩法： 二肖連中  三肖連中  四肖連中
const initZodicCombKey = () => {
  let data = {}

  for (let i = 2; i < 5; i++) {
    const arr = []
    let supKey = ''
    if (i === 2) supKey = 'zodic_comb_two'
    else if (i === 3) supKey = 'zodic_comb_three'
    else supKey = 'zodic_comb_four'

    // ALL:ZODIAC:CHOOSE:2:MATCH:2:CUR 系列
    oddsZodiacArray.map(it => arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:${i}:${it}`))
    arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:${i}`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'zodicComb',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 生肖連(中/不中) 的子玩法： 二肖連不中 三肖連不中 四肖連不中
const initZodicCombLoseKey = () => {
  let data = {}
  for (let i = 2; i < 5; i++) {
    const arr = []
    let supKey = ''
    if (i === 2) supKey = 'zodic_comb_two_lose'
    else if (i === 3) supKey = 'zodic_comb_three_lose'
    else supKey = 'zodic_comb_four_lose'

    // ALL:ZODIAC:CHOOSE:2:MATCH:0:CUR 系列
    oddsZodiacArray.map(it => arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:0:${it}`))
    arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:0`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'zodicComb',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 平特一尾/尾數連 的子玩法：  平特一尾   一尾不中
const initOneTailKey = () => {
  const arr = []
  let data = {}

  const fn = (oddsKey) => {
    if (oddsKey.includes('EXCLUDE')) return 'sp_no_one_tail' // 一尾不中
    else return 'sp_one_tail' // 平特一尾
  }

  // ALL:TAIL:0 系列
  arr.push(...Array.from({ length: 10 }, (v, i) => `ALL:TAIL:${i}`))

  // ALL:TAIL:0:EXCLUDE 系列
  arr.push(...Array.from({ length: 10 }, (v, x) => `ALL:TAIL:${x}:EXCLUDE`))

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey: 'count-any-tail-equal',
      supKey: fn(oddsKey),
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 平特一尾/尾數連 的子玩法： 二尾連中  三尾連中  四尾連中  二尾連不中  三尾連不中  四尾連不中
const initTailKey = () => {
  let data = {}

  const fn = (oddsKey) => {
    if (oddsKey.includes('2:MATCH:2')) return 'sp_two_tail'
    if (oddsKey.includes('3:MATCH:3')) return 'sp_three_tail'
    if (oddsKey.includes('4:MATCH:4')) return 'sp_four_tail'
    if (oddsKey.includes('2:MATCH:0')) return 'sp_no_two_tail'
    if (oddsKey.includes('3:MATCH:0')) return 'sp_no_three_tail'
    if (oddsKey.includes('4:MATCH:0')) return 'sp_no_four_tail'
  }

  for (let i = 2; i < 5; i++) {
    const arr = []

    // ALL:TAIL:CHOOSE:2:MATCH:2:0 系列
    arr.push(...Array.from({ length: 10 }, (v, x) => `ALL:TAIL:CHOOSE:${i}:MATCH:${i}:${x}`))
    arr.push(`ALL:TAIL:CHOOSE:${i}:MATCH:${i}`)

    // ALL:TAIL:CHOOSE:2:MATCH:0:0 系列
    arr.push(...Array.from({ length: 10 }, (v, x) => `ALL:TAIL:CHOOSE:${i}:MATCH:0:${x}`))
    arr.push(`ALL:TAIL:CHOOSE:${i}:MATCH:0`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'count-any-tail-equal',
          supKey: fn(oddsKey),
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 過關 的子玩法：特碼球
const initPassSpBallKey = (locate) => {
  const mainKey = 'pass'
  const arr = []
  let data = {}

  oddsKeyArray.forEach(it => arr.push(`${locate}:PASS:${it}`))
  oddsColorArray.forEach(it => arr.push(`${locate}:PASS:${it}`))

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey: 'sp_ball', // 特碼球
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 過關 的子玩法： 第一球、第二球、第三球、第四球、第五球、第六球
const initPassBallKey = () => {
  let data = {}

  for (let i = 1; i < 7; i++) {
    const arr = []
    let supKey = ''
    if (i === 1) supKey = 'firstBall'
    else if (i === 2) supKey = 'secondBall'
    else if (i === 3) supKey = 'thirdBall'
    else if (i === 4) supKey = 'fourthBall'
    else if (i === 5) supKey = 'fifthBall'
    else supKey = 'sixthBall'

    oddsKeyArray.forEach(it => arr.push(`${i}:PASS:${it}`))
    oddsColorArray.forEach(it => arr.push(`${i}:PASS:${it}`))

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'pass',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 過關 的子玩法：(串兩關/串三關/串四關/串五關/串六關/串七關)
const initPassLevelKey = () => {
  let data = {}

  for (let i = 2; i < 8; i++) {
    const arr = []
    let supKey = ''
    if (i === 2) supKey = 'pass_two_level' // 串兩關
    else if (i === 3) supKey = 'pass_three_level' // 串三關
    else if (i === 4) supKey = 'pass_four_level' // 串四關
    else if (i === 5) supKey = 'pass_five_level' // 串五關
    else if (i === 6) supKey = 'pass_six_level' // 串六關
    else supKey = 'pass_seven_level' // 串七關

    arr.push(`ALL:PASS:${i}`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'pass',
          supKey,
          groupKey: '-'
        }
        return root
      }, {})
    }
  }
  return data
}

// 七碼位數 的子玩法：(七碼單位數/七碼大位數/七碼雙位數/七碼小位數)
const initSevenDigitKey = () => {
  let data = {}
  const arr = []

  oddsKeyArray.forEach(it => { arr.push(...Array.from({ length: 8 }, (v, i) => `CHOOSE:${it}:${i}`)) })
  const fn = (oddsKey) => {
    if (oddsKey.includes('ODD')) return 'seven_odd'
    if (oddsKey.includes('UNDER')) return 'seven_under'
    if (oddsKey.includes('EVEN')) return 'seven_even'
    if (oddsKey.includes('OVER')) return 'seven_over'
  }

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey: 'sevenDigit',
      supKey: fn(oddsKey),
      groupKey: oddsKey
    }
    return root
  }, {})
  return data
}

// 多選中一 的子玩法：(五選中一/六選中一/七選中一/八選中一/九選中一/十選中一)
const initMoreChoiceKey = () => {
  let data = {}

  for (let i = 5; i < 11; i++) {
    const arr = []
    let supKey = ''
    if (i === 5) supKey = 'chose_51'// 五選中一
    else if (i === 6) supKey = 'chose_61'// 六選中一
    else if (i === 7) supKey = 'chose_71'// 七選中一
    else if (i === 8) supKey = 'chose_81'// 八選中一
    else if (i === 9) supKey = 'chose_91'// 九選中一
    else supKey = 'chose_101'// 十選中一

    arr.push(`CHOOSE:${i}:MATCH:1`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'doxuan_zhongi',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 多選不中 的子玩法：(五選不中/六選不中/七選不中/八選不中/九選不中/十選不中)
const initMoreChoiceNoWinKey = () => {
  let data = {}

  for (let i = 5; i < 11; i++) {
    const arr = []
    let supKey = ''
    if (i === 5) supKey = 'chose_50'// 五選不中
    else if (i === 6) supKey = 'chose_60'// 六選不中
    else if (i === 7) supKey = 'chose_70'// 七選不中
    else if (i === 8) supKey = 'chose_80'// 八選不中
    else if (i === 9) supKey = 'chose_90'// 九選不中
    else supKey = 'chose_100'// 十選不中

    arr.push(`CHOOSE:${i}:MATCH:0`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'doxuan_bozhong',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 天地碰
const initSkyKey = () => {
  const mainKey = 'sky_earth_pon'
  const supKey = 'sky_23'

  return {
    'NL:1:BUMP:SP:1': {
      mainKey,
      supKey,
      groupKey: 'sky_2'
    },
    'NL:2:BUMP:SP:1': {
      mainKey,
      supKey,
      groupKey: 'sky_3'
    }
  }
}

// 特串 的子玩法：特串二三
const initSpChuanKey = () => {
  const mainKey = 'set_two_for_sp_and_straight'
  const supKey = 'spChuan_23'

  return {
    'CHOOSE:2:MATCH:1:NL:SP': {
      mainKey,
      supKey,
      groupKey: 'spPass_2'
    },
    'CHOOSE:3:MATCH:2:NL:SP': {
      mainKey,
      supKey,
      groupKey: 'spPass_3'
    }
  }
}

// 台號
const initTaiNumberKey = () => {
  const mainKey = 'taiNumber' // 台號
  const supKey = ''
  let arr = []
  let data = {}

  arr = Array.from({ length: 100 }, (v, i) => `COMBINATION:${i}`)
  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey,
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

//  特三
const initSpecialThreeKey = () => {
  const mainKey = 'spThree'
  const supKey = ''
  let arr = []
  let data = {}

  arr = Array.from({ length: 1000 }, (v, i) => `COMBINATION:SP:${i}`)
  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey,
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

export default {
  ...initStarKey(),
  ...initWholeCarKey(),
  ...initPositiveCodeKey(),
  ...initSpecialCodeKey(),
  ...initBallColorKey(),
  ...initBallColorKey('SP'),
  ...initZodicKey(),
  ...initZodicSpKey('SP'),
  ...initZodicSpKey('NL'),
  ...initZodicSpKey('ALL'),
  ...initNoZodicKey('ALL', 'EXCLUDE'),
  ...initSumTwoSideKey('ALL'),
  ...initSpZodicKey(),
  ...initZodicCombKey(),
  ...initZodicCombLoseKey(),
  ...initOneTailKey(),
  ...initTailKey(),
  ...initPassSpBallKey('SP'),
  ...initPassBallKey(),
  ...initPassLevelKey(),
  ...initSevenDigitKey(),
  ...initMoreChoiceKey(),
  ...initMoreChoiceNoWinKey(),
  ...initSkyKey(),
  ...initSpChuanKey(),
  ...initTaiNumberKey(),
  ...initSpecialThreeKey()
}
